import {ProjectTypeEnum} from 'api';

export const ROUTES = {
  MyProjects: '/projects',
  TechProcess: `/projects/${ProjectTypeEnum.TechProcess.toLowerCase()}/:id/:checkpointId`,
  SamplesAndBlends: `/projects/${ProjectTypeEnum.SamplesAndOilBlend.toLowerCase()}/:id/:checkpointId`,
  System: '/system'
};
